import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getEmployerDrivers = groupId =>
  call(websocketFetch, 'get_employer_hr_drivers', { group_id: groupId });
